import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchKanbanTicketAsDeleted } from '../services/patchKanbanTicketAsDeleted.service';

export const deleteKanbanTicket = createAsyncThunk(
  'kanban/deleteKanbanTicket',
  async ({ projectId, ticketId }) => {
    const deletedTicket = await patchKanbanTicketAsDeleted(projectId, ticketId);
    return deletedTicket;
  }
);
